import React from 'react'
import PropTypes from 'prop-types'
import PageElementWrapper from './PageElementWrapper'
import RootElementWrapper from './RootElementWrapper'
import UserTools from '@components/UserTools'
import { isPreviewPage } from '@utils'
import Header from '@components/Header'
import Footer from '@components/Footer'
import Cookies from '@components/Cookies'
import { Flex, GlobalStyle } from '@components/Globals'
import { BodyWrapper } from '@components/Layout/style'
import { ContentTypeContext } from '@hooks'

const Layout = ({
  children,
  hideContactUs = false,
  contentType = 'page',
  ...rest
}) => {
  return (
    <ContentTypeContext.Provider value={contentType}>
      <GlobalStyle />
      <Header {...rest} />
      <BodyWrapper {...rest}>
        <Flex direction="column" shrink="0" grow="1" vAlign="stretch">
          {children}
        </Flex>
      </BodyWrapper>
      <Footer {...rest} />
      <Cookies />
      {!isPreviewPage() && <UserTools {...rest} />}
    </ContentTypeContext.Provider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  contentType: PropTypes.string,
}

export default Layout
export { PageElementWrapper, RootElementWrapper }
